import React from "react";
import "../Assets/Css/webfooter.css";
import { Col, Container, Row } from "react-bootstrap";
import { FaLocationDot, MdPhone } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import footerBanner from "../Assets/Images/homebannerimg3.png";
export default function WebFooter() {
  return (
    <>
      <Col lg={12}>
        <div
          className="footer-section text-white p-3"
          style={{
            backgroundImage: `url(${footerBanner})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "100%",
            minHeight: "350px",
            position: "relative",
          }}
        >
          <div className="footer-overlay"></div>

          <Container>
            <Row className="mt-5">
              <Col lg={5}>
                <h5 className="text-white">Delta Engineering</h5>
                <p className="text-white">
                  At Delta Engineering, we empower companies of all sizes with
                  innovative engineering solutions — enabling startups to grow,
                  enterprises to streamline, and operations to perform at their
                  best.
                </p>
              </Col>
              <Col lg={3} className="justify-content-end">
                <h5 className="text-light">Quick Links</h5>
                <ul className="list-unstyled text-white">
                  <li>
                    <MdKeyboardDoubleArrowRight />
                    <NavLink to="/" className="quick-links">
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <MdKeyboardDoubleArrowRight />
                    <NavLink to="/about" className="quick-links">
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <MdKeyboardDoubleArrowRight />
                    <NavLink to="/facilities" className="quick-links">
                      Facilities
                    </NavLink>
                  </li>
                  <li>
                    <MdKeyboardDoubleArrowRight />
                    <NavLink to="/ourProducts" className="quick-links">
                      Products
                    </NavLink>
                  </li>
                    <li>
                    <MdKeyboardDoubleArrowRight />
                    <NavLink to="/data" className="quick-links">
                      Products Data
                    </NavLink>
                  </li>
                  <li>
                    <MdKeyboardDoubleArrowRight />
                    <NavLink to="contact" className="quick-links">
                      ContactUs
                    </NavLink>
                  </li>
                </ul>
              </Col>

              <Col lg={4}>
                <h5 style={{ color: "white" }}>Connect With Us</h5>

                <div className="text-white mb-2">
                  <FaLocationDot color="white" /> Plot No: D1/32 , MIDC , AMBAD,
                  NASIK , 422010 ,MAHARSHTRA
                </div>
                <div className="text-white mb-2">
                  <a
                    href="https://wa.me/919021399351"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    {" "}
                    <FaPhoneAlt size={20} color="white" />
                    <i
                      className="fab fa-whatsapp"
                      style={{ fontSize: "20px", color: "white" }}
                    ></i>
                    +91 9021399351
                  </a>
                </div>

                <div className="text-white">
                  <a
                    href="mailto:info@deltaen.in"
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span className="text-white">
                      <MdEmail color="white" /> info@deltaen.in
                    </span>
                  </a>
                </div>
              </Col>
            </Row>

            <div className="text-white mt-3 footerend text-center">
              <hr />
              <p>
                © {new Date().getFullYear()} <span>Delta Engineering </span> |
                <a
                  href="https://www.bighostindia.in/"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  {" "}
                  Design By : BigHost India Private Limited
                </a>
              </p>
            </div>
          </Container>
        </div>
      </Col>
    </>
  );
}
